import {ReasoningEffort} from "digiteq-ai-portal-client-lib";

export const environment = {
	apiUrl: 'https://api.openai-test.digiteq.tech',
  application: 'AI_Portal_FE_TEST',
  authentication: {
    authority: 'https://identity.tskoda.vwgroup.com/realms/standard',
    clientId: 'dqai_87c658e9',
    audience: 'dqai_87c658e9',
    renewTimeBeforeTokenExpiresInSeconds: 30,
    scope: 'openid email profile sa_roles offline_access audience web-origins'
  },
  appInsights: {
    endpointUrl: 'https://api.openai-test.digiteq.tech/telemetry/track',
    dummyKey: 'e63c66f8-0564-4cb1-b959-aa9b32bf4fc4'
  },
  prefillNewIndexValues: {
    lastMessages: 20,
    documentCount: 20,
    scoringProfile: 'daise-scoring-profile',
    rrfConstant: 60,
    synthesisReasoningEffortLevel: ReasoningEffort.Medium,
    endpoint: 'https://srch-ai-portal-prod-gg5p.search.windows.net',
    storageEndpoint: 'https://staiportaltestihce.blob.core.windows.net/',
  }
};
